import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

export function useRdInstallmentConfig() {
  return useQuery({
    queryKey: ['rd-installment-config'],
    queryFn: async () => {
      const response = await rdEquipamentosService.getInstallmentConfig();
      if (!response.success || !response.data) {
        throw new Error(
          response.error ||
            'Erro ao carregar a configuração de parcelamento do produto'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
  });
}
